import React from 'react';
import styles from './Input.module.scss';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Input = ({ className, ...props }) => {
  return <input className={classNames(styles.input, className)} {...props} />;
};

Input.propTypes = {
  className: PropTypes.string,
};

Input.defaultProps = {
  className: null,
};

export default Input;
